module.exports = __webpack_public_path__ + "img/Wordmark.e08e8bf.svg";